import { useMemo } from 'react'
import { findDiscountOnTour } from 'lib/tours/tourUtils'

const useTourDiscount = (tour: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary, variationId?: string, departureIds?: Array<string>) => {
  return useMemo(
    () => findDiscountOnTour(tour, variationId, departureIds),
    [tour, variationId, departureIds],
  )
}

export default useTourDiscount
